var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhoneSlim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08008 10.8311H5.9375C6.77246 10.8311 7.3291 10.2842 7.3291 9.47363V1.46582C7.3291 0.655273 6.77246 0.113281 5.9375 0.113281H2.08008C1.23047 0.113281 0.664062 0.655273 0.664062 1.46582V9.47363C0.664062 10.2842 1.23047 10.8311 2.08008 10.8311ZM2.24609 9.8252C1.86035 9.8252 1.64062 9.61523 1.64062 9.24414V1.69531C1.64062 1.32422 1.86035 1.11426 2.24609 1.11426H2.44629V1.3584C2.44629 1.57324 2.58789 1.71484 2.79785 1.71484H5.2002C5.41016 1.71484 5.55176 1.57324 5.55176 1.3584V1.11426H5.74707C6.13281 1.11426 6.35254 1.3291 6.35254 1.7002V9.24414C6.35254 9.61523 6.13281 9.8252 5.74707 9.8252H2.24609ZM2.69531 9.43945H5.30273C5.44434 9.43945 5.55176 9.3418 5.55176 9.19043C5.55176 9.04395 5.44434 8.94629 5.30273 8.94629H2.69531C2.55371 8.94629 2.44629 9.04395 2.44629 9.19043C2.44629 9.3418 2.55371 9.43945 2.69531 9.43945Z",
    fill: "#89898E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneSlim);
export default __webpack_public_path__ + "static/media/icon-phone-slim.28274241731e4133eb8e6374ca17cc04.svg";
export { ForwardRef as ReactComponent };